import { RootState } from "core-integration/src/store";
import { getElement } from "core-integration/src/store/elements/reducers";
import {
  getElementEventOpponents,
  getFixturesForEventByTeam,
} from "core-integration/src/store/fixtures/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import { visuallyHidden } from "../../styles/utils.css";
import { getAccessibleFixtureLabels } from "../../utils/fixtures";
import {
  elementMultiFixtures,
  elementSingleFixture,
} from "./fixtureGroupForElement.css";
import { MultiProps } from "./types";

const FixtureGroupForElement = ({ elementId, eventId }: MultiProps) => {
  const { fixtures: fixturesDefaults } = usePlosTranslations();
  const element = useSelector((state: RootState) =>
    getElement(state, elementId),
  );
  const fixturesForEventByTeam = useSelector((state: RootState) =>
    eventId ? getFixturesForEventByTeam(state, eventId) : null,
  );

  const fixtures =
    element && fixturesForEventByTeam
      ? fixturesForEventByTeam[element.team]
      : [];

  const elementEventOpponents = useSelector((state: RootState) =>
    getElementEventOpponents(state, element, fixtures),
  );

  const teamsById = useSelector(getTeamsById);

  const accessibleFixtureLabels = getAccessibleFixtureLabels(
    element,
    fixtures,
    teamsById,
  );

  if (elementEventOpponents.length === 1) {
    return (
      <span className={elementSingleFixture}>
        <span className={visuallyHidden}>
          {fixturesDefaults.fixture}: {accessibleFixtureLabels[0]}
        </span>
        <span aria-hidden="true">{elementEventOpponents[0]}</span>
      </span>
    );
  }

  if (elementEventOpponents.length > 1) {
    return (
      <span className={elementMultiFixtures}>
        <span className={visuallyHidden}>
          {fixturesDefaults.fixtures}: {accessibleFixtureLabels.join(", ")}
        </span>
        <span aria-hidden="true">{elementEventOpponents.join(", ")}</span>
      </span>
    );
  }

  return (
    <div>
      <span aria-hidden="true">-</span>
      <span className={visuallyHidden}>{fixturesDefaults.noFixture}</span>
    </div>
  );
};
export default FixtureGroupForElement;
